module.exports = __webpack_public_path__ + "static/yelobankmedia-aa511d613ef300ab3f909688e0bf6669.jpg";